import axios from "axios";
import { BASE_URL_ML } from "../../utils/constants";
const ai = axios.create({
  baseURL: BASE_URL_ML,
  headers: {
    "Content-Type": "application/json",
  },
});

// api.interceptors.request.use((config) => {
//   const accessToken = localStorage.getItem("authToken");

//   if (accessToken && config.auth !== false) {
//     config.headers.Authorization = `Bearer ${accessToken}`;
//   }

//   return config;
// });

export default ai;
